import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyDGtDoHAHtWbwyRfrstMEay3hHz7TdJlxg",
  authDomain: "sushiscribe-portal.firebaseapp.com",
  projectId: "sushiscribe-portal",
  storageBucket: "sushiscribe-portal.appspot.com",
  messagingSenderId: "832233205981",
  appId: "1:832233205981:web:c7738b6818ca4ff9baeb34"
};

const app = initializeApp(firebaseConfig);

if (typeof window !== "undefined") {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider('6LdB7M4tAAAAAK5RUWmsPmtk-Q95vGM09rr119d8'),
    isTokenAutoRefreshEnabled: true
  });
}

export const auth = getAuth(app);
export const db = getFirestore(app);